import React from "react";
import { Navigate } from "react-router-dom";
import GetStorage from "../services/Storage";
const ProtectedRoutes = ({ children }) => {
const user = GetStorage.get("xAuthToken");
  if (!user) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoutes;
